<template lang="pug">
  BForm(@submit.prevent="submit" @keyup="clearError")
    BCard(:title="$t('login.title')")
      BFormGroup
        BFormInput(
          name="email"
          :placeholder="$t('login.email')"
          v-model="data.email"
          v-validate="{ required: true }"
          :data-vv-as="$t('login.email')"
          :state="!isError('email')"
        )
        BFormInvalidFeedback {{ getError('email') }}
      BFormGroup
        BFormInput(
          type="password"
          name="password"
          :placeholder="$t('login.password')"
          v-model="data.password"
          v-validate="{ required: true }"
          :data-vv-as="$t('login.password')"
          :state="!isError('password')"
        )
        BFormInvalidFeedback {{ getError('password') }}
      BButton(
        type="submit"
        variant="success"
        block
        pill
        slot="footer"
        :disabled="disabledButton"
      ) {{ $t('login.button') }}
</template>

<script>
import validation from '@/mixins/validation'
import { mapActions } from 'vuex'

export default {
  mixins: [validation],
  data: () => ({
    data: {
      email: null,
      password: null
    }
  }),
  methods: {
    ...mapActions('auth', ['login']),
    async submit () {
      this.formValidation.saving = true

      try {
        await this.login(this.data)
      } catch (error) {
        if (error.response?.status === 422) {
          this.formValidation.errors = error.response?.data?.error?.detail
        }
      }

      this.formValidation.saving = false
    }
  }
}
</script>
